import React from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import { useResponsive } from 'ahooks';
import { Icon, Typography, Badge } from '@shore/react-gravity';

export const StyledOnboardingStep = styled.div`
  cursor: pointer;
`;

type OnboardingStepProps = {
  id: string;
  title: string;
  description: string;
  isMandatory: boolean;
  completedAt: string | null;
  isLastStep: boolean;
  onStepClick: (id: string) => void;
  onSkipStepClick: (id: string) => void;
};

export function OnboardingStep({
  id,
  title,
  description,
  isMandatory,
  completedAt,
  isLastStep,
  onStepClick,
  onSkipStepClick: _onSkipStepClick,
}: OnboardingStepProps) {
  const responsive = useResponsive();
  const isMobile = !responsive.md;

  const stepContainerClasses = cx(
    'gv-flex gv-justify-between gv-items-center gv-px-lg',
    {
      'gv-mode-condensed gv-py-sm': isMobile,
      'gv-py-md': !isMobile,
    }
  );

  // TODO Notes:
  // Add skip button for optional steps and handle the click event to skip the step

  return (
    <>
      <StyledOnboardingStep
        key={id}
        className={stepContainerClasses}
        onClick={() => onStepClick(id)}
      >
        <div className="gv-flex gv-justify-between gv-w-full gv-gap-md gv-items-center">
          <div className="gv-gap-sm">
            <Typography variant="text" bold size={'sm'}>
              {title}
            </Typography>

            {!isMobile && (
              <Typography variant="text" size={'sm'}>
                {description}
              </Typography>
            )}
          </div>

          {completedAt && <Badge variant="success">Completed</Badge>}
          {!completedAt && isMandatory && <Badge variant="info">Pending</Badge>}
          {!completedAt && !isMandatory && (
            <Badge variant="generic">Optional</Badge>
          )}
        </div>
        <span className="gv-button gv-button-icon gv-justify-end">
          <Icon name="arrow_forward" size={isMobile ? 'small' : 'large'} />
        </span>
      </StyledOnboardingStep>

      {!isLastStep && <div className="gv-divider"></div>}
    </>
  );
}
